
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import defautphoto from '@/assets/timg.jpg'
import config from '@/config'
import { myDeal } from '@/api/youzheng.js'
import { isWorker, getDealList } from '@/api/zhigongxiaojia.js'
export default {
name: 'userinfo',
components: {
Group,
Cell,
Badge
},
data () {
return {
defautphoto: defautphoto,
baseUrl: config.baseUrl,
accounttype: this.$store.state.user.personObj.accounttype,
idtype: 2,
isqyb: this.$store.state.user.personObj.isqyb,
lawyerNum: 0,
mailboxNum: 0,
clinicNum: 0,
isWorker1: 0,
isWorker2: 0,
isWorker3: 0,
xjnum: '',
homeNum: '',
medicaleNum: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
getmyDeal () {
if (this.accounttype === 4) {
this.idtype = 1
}
myDeal({
accountid: this.accountid,
idtype: this.idtype,
userid: this.userid
}).then(res => {
this.lawyerNum = res.obj.lawyerNum
this.mailboxNum = res.obj.mailboxNum
this.clinicNum = res.obj.clinicNum
this.isWorker1 = res.obj.isWorker1
this.isWorker2 = res.obj.isWorker2
this.isWorker3 = res.obj.medicalWorker
this.homeNum = res.obj.homeNum
this.xjnum = res.obj.staffNum
this.medicaleNum = res.obj.medicaleNum
})
},
lawyerClick () {
if (this.accounttype === 4) {
this.$router.push({ name: 'mylawyerAsk' })
} else {
this.$router.push({ name: 'lawyerAsk' })
}
},
mailClick () {
if (this.accounttype === 0 || this.accounttype === 1 || (this.isqyb === 2 && this.accounttype === 3 || this.accounttype === 4)) {
this.$router.push({ name: 'myMailCommon' })
} else if (this.accounttype === 2 || this.accounttype === 3) {
if (this.isqyb === 1) {
this.$router.push({ name: 'myMailWorkDaiban', params: { selected: 2, tabIndex: 0 } })
} else {
this.$router.push({ name: 'myMailWorkQyDaiban', params: { selected: 2, tabIndex: 0 } })
}
}
},
xiqueClick () {
this.$router.push({ name: 'xiqueClincConsult' })
},
xiaojiaClick () {
this.$router.push({ name: 'zhigongxiaojiaWorkspaceDealList' })
},
xiaowuClick () {
this.$router.push({ name: 'mamixiaowuWorkspaceDealList' })
},
huzhuClick () {
this.$router.push({ name: 'yiliaohuzhuWorkspace' })
}






















},
created () {
this.getmyDeal()

},
mounted () { }
}
